<template>
  <b-form @submit.prevent="evOnSubmit">
    <b-row>
      <b-col cols="12" class="mt-0 pt-0">
        <span>{{ user.first_security_question_statement }}</span>
        <v-text-field-password
          ref="autofocus"
          :disabled="loading"
          v-model="answer1"
        />
      </b-col>
      <b-col cols="12" class="mt-0 pt-0">
        <span>{{ user.last_security_question_statement }}</span>
        <v-text-field-password :disabled="loading" v-model="answer2" />
      </b-col>
      <b-col v-if="errors.length > 0" cols="12" class="mt-0 pt-0">
        <errors-messages :errors="errors" />
      </b-col>
      <b-col cols="12" class="mt-0 pt-0">
        <b-row no-gutters align-h="between">
          <b-col cols="auto">
            <v-btn text @click="$emit('return')">
              <font-awesome-icon class="text-twenty mr-2" icon="arrow-left" />
              VOLTAR
            </v-btn>
          </b-col>
          <b-col cols="auto">
            <v-btn type="submit" class="btn-acess" :disabled="loading">
              ACESSAR
            </v-btn>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import VTextFieldPassword from "../Components/VTextFieldPassword.vue";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import { set } from "idb-keyval";

export default {
  name: "OfflineSignIn",

  components: { VTextFieldPassword, ErrorsMessages },

  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    this.errors = [];
    this.loading = false;
    this.answer1 = "";
    this.answer2 = "";
    this.$refs.autofocus.focus();
  },

  data() {
    return {
      errors: [],
      loading: false,
      answer1: "",
      answer2: "",
    };
  },

  methods: {
    async evOnSubmit() {
      try {
        this.loading = true;

        this.errors = [];

        if (!this.answer1 || !this.answer2)
          this.errors.push("Informe todas as respostas");
        else if (
          this.user.first_answer != this.answer1 ||
          this.user.last_answer != this.answer2
        )
          this.errors.push("RESPOSTAS INVÁLIDAS");

        if (this.errors.length == 0) {
          let user = this.user;
          let permissions = user.permissions;
          delete user.permissions;
          await set("user", user);
          sessionStorage.setItem("accessed_offline", JSON.stringify(true));
          sessionStorage.setItem("user", JSON.stringify(user));
          sessionStorage.setItem("permissions", JSON.stringify(permissions));
          this.$router.push({ name: "dashboard" });
        }
      } catch (error) {
        console.log(error);
        this.errors.push("Ocorreu um erro no aplicativo");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>